const note = {
    version: '1.3.0',
    date: '2026-09-16',
    tags: ['Nyt'],
    body: `
- **Release Notes.** Denne side. Her står, hvad der er ændret i kalenderen og i admin dashboardet, hver for sig, med dato og version.
`,
};

export default note;
